import { VendorPriceFormat } from "../helpers/priceFormatter";

export interface Vendor {
  id: number;
  channel: string;
  oldName?: string;
  locale: string;
  country: string;
  prices: VendorPriceFormat;
}

//todo Ids must match https://github.com/albumprinter/storefront-public-configuration/blob/master/source_configs/vendors.json move here and lookup
export const vendors: Vendor[] = [
  {
    id: 1,
    channel: "albelli.nl",
    locale: "nl-NL",
    country: "NL",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 2,
    channel: "albelli.be",
    locale: "nl-BE",
    country: "BE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 3,
    channel: "albelli.de",
    locale: "de-DE",
    country: "DE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true
    }
  },
  {
    id: 4,
    channel: "monalbumphoto.fr",
    locale: "fr-FR",
    country: "FR",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 5,
    channel: "onskefoto.se",
    oldName: "albelli.se",
    locale: "sv-SE",
    country: "SE",
    prices: {
      currencySymbol: "kr",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
      dropZeroDecimals: true
    }
  },
  {
    id: 6,
    channel: "fotoknudsen.no",
    locale: "nb-NO",
    country: "NO",
    prices: {
      currencySymbol: "kr",
      decimalSeparator: ",",
      thousandsSeparator: " ",
      zeroDecimalsReplacement: "-"
    }
  },
  {
    id: 7,
    channel: "bonusprint.co.uk",
    locale: "en-GB",
    country: "UK",
    prices: {
      currencySymbol: "£",
      decimalSeparator: ".",
      thousandsSeparator: ","
    }
  },
  {
    id: 8,
    channel: "posterxxl.de",
    locale: "de-DE",
    country: "PXXLDE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true
    }
  },
  {
    id: 9,
    channel: "posterxxl.at",
    locale: "de-AT",
    country: "AT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true
    }
  },
  {
    id: 10,
    channel: "b2b.posterxxl.de",
    locale: "de-DE",
    country: "PXXLDE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      appendAsterisk: true,
      currencySymbolAppended: true
    }
  },
  {
    id: 11,
    channel: "photobox.co.uk",
    locale: "en-GB",
    country: "UK",
    prices: {
      currencySymbol: "£",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 12,
    channel: "photobox.fr",
    locale: "fr-FR",
    country: "FR",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 13,
    channel: "photobox.ie",
    locale: "en-IE",
    country: "IE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 14,
    channel: "photobox.it",
    locale: "it-IT",
    country: "IT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 15,
    channel: "photobox.dk",
    locale: "da-DK",
    country: "DK",
    prices: {
      currencySymbol: "kr.",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 16,
    channel: "hofmann.es",
    locale: "es-ES",
    country: "ES",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 17,
    channel: "hofmann.pt",
    locale: "pt-PT",
    country: "PT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8000,
    channel: "vistaprint.nl",
    locale: "nl-NL",
    country: "NL",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 8001,
    channel: "vistaprint-nl.be",
    locale: "nl-NL",
    country: "BE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 8002,
    channel: "vistaprint-fr.be",
    locale: "fr-FR",
    country: "BE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 8003,
    channel: "vistaprint.de",
    locale: "de-DE",
    country: "DE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8004,
    channel: "vistaprint.fr",
    locale: "fr-FR",
    country: "FR",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8005,
    channel: "vistaprint.co.uk",
    locale: "en-GB",
    country: "UK",
    prices: {
      currencySymbol: "£",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8006,
    channel: "vistaprint.it",
    locale: "it-IT",
    country: "IT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8007,
    channel: "vistaprint.es",
    locale: "es-ES",
    country: "ES",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8008,
    channel: "vistaprint.se",
    locale: "sv-SE",
    country: "SE",
    prices: {
      currencySymbol: "kr",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true,
      dropZeroDecimals: true
    }
  },
  {
    id: 8009,
    channel: "vistaprint.no",
    locale: "nb-NO",
    country: "NO",
    prices: {
      currencySymbol: "kr",
      decimalSeparator: ",",
      thousandsSeparator: " ",
      zeroDecimalsReplacement: "-"
    }
  },
  {
    id: 8010,
    channel: "vistaprint.in",
    locale: "en-IN",
    country: "IN",
    prices: {
      currencySymbol: "₹",
      decimalSeparator: ".",
      thousandsSeparator: ","
    }
  },
  {
    id: 8011,
    channel: "vistaprint.sg",
    locale: "en-SG",
    country: "SG",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8013,
    channel: "vistaprint.com.au",
    locale: "en-AU",
    country: "AU",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8014,
    channel: "vistaprint.co.nz",
    locale: "en-NZ",
    country: "NZ",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8018,
    channel: "vistaprint-en.com",
    locale: "en-US",
    country: "US",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8019,
    channel: "vistaprint-en.ca",
    locale: "en-CA",
    country: "CA",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8020,
    channel: "vistaprint-fr.ca",
    locale: "fr-CA",
    country: "CA",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8021,
    channel: "vistaprint-es.com",
    locale: "es-US",
    country: "US",
    prices: {
      currencySymbol: "$",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8022,
    channel: "vistaprint.ie",
    locale: "en-IE",
    country: "IE",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ".",
      thousandsSeparator: ",",
      currencySymbolNoSpacing: true
    }
  },
  {
    id: 8023,
    channel: "vistaprint.pt",
    locale: "pt-PT",
    country: "PT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8024,
    channel: "vistaprint.dk",
    locale: "da-DK",
    country: "DK",
    prices: {
      currencySymbol: "kr.",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8025,
    channel: "vistaprint.fi",
    locale: "fi-FI",
    country: "FI",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: ".",
      currencySymbolAppended: true
    }
  },
  {
    id: 8026,
    channel: "vistaprint.at",
    locale: "de-AT",
    country: "AT",
    prices: {
      currencySymbol: "€",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 8027,
    channel: "vistaprint-it.ch",
    locale: "it-CH",
    country: "CH",
    prices: {
      currencySymbol: "CHF",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 8028,
    channel: "vistaprint-fr.ch",
    locale: "fr-CH",
    country: "CH",
    prices: {
      currencySymbol: "CHF",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  },
  {
    id: 8029,
    channel: "vistaprint-de.ch",
    locale: "de-CH",
    country: "CH",
    prices: {
      currencySymbol: "CHF",
      decimalSeparator: ",",
      thousandsSeparator: "."
    }
  }
];
